import Vue from 'vue';
import VueRouter from 'vue-router';
import { loadTranslations } from '@/services/translations';

import MainApp from '@/MainApp.vue';
import AuthApp from '@/AuthApp.vue';

import config from '@/config';
import store from '@/store';
import helpers from '@/services/helpers';

const selectedLanguage = localStorage.getItem('langId') || 'bs';

const translations = loadTranslations(selectedLanguage);

Vue.use(VueRouter);

const routes = [
  {
    path: '/auth',
    component: AuthApp,
    children: [
      {
        path: 'login',
        name: 'Login',
        meta: {
          title: translations.login
        },
        component: () => import('@/components/Auth/Login.vue')
      },
      {
        path: 'logout',
        name: 'LogOut',
        meta: {
          title: translations.logout
        },
        component: () => import('@/components/Auth/LogOut.vue')
      },
      // {
      //   path: 'register',
      //   name: 'Register',
      //   meta: {
      //     title: translations.register
      //   },
      //   component: () => import('@/components/Auth/Register.vue')
      // },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        meta: {
          title: translations.forgotPassword
        },
        component: () => import('@/components/Auth/ForgotPassword.vue')
      },
    ],
  },
  {
    path: '/',
    component: MainApp,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        meta: {
          title: translations.homePageTitle
        },
        component: () => import('@/components/Dashboard.vue')
      },
      {
        path: 'media-library',
        name: 'MediaLibrary',
        meta: {
          title: 'Biblioteka',
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi media biblioteku",
          ],
        },
        component: () => import('@/views/MediaLibrary.vue')
      },
      {
        path: 'companies',
        name: 'Companies',
        meta: {
          title: translations.companies,
          permissions: [
            "Vidi 'Klijenti'",
            "Vidi kompanije",
          ],
        },
        component: () => import('@/components/companies/List.vue')
      },
      {
        path: '/companies/add',
        name: 'AddCompany',
        meta: {
          title: translations.addCompany,
          parent: 'Companies',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati kompanije",
          ],
        },
        component: () => import('@/components/companies/Add.vue')
      },
      {
        path: '/companies/edit/:companyId',
        name: 'EditCompany',
        meta: {
          title: translations.editCompany,
          parent: 'Companies',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati kompanije",
          ],
        },
        component: () => import('@/components/companies/Edit.vue')
      },
      {
        path: '/categories',
        name: 'Categories',
        meta: {
          title: translations.categories,
          permissions: [
            'Vidi kategorije',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/categories/List.vue')
      },
      {
        path: '/companies/edit/superbonus/:companyId/:superbonusid',
        name: 'EditSuperBonus',
        meta: {
          title: translations.editSuperBonus,
          parent: 'EditCompany',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati kompanije",
          ],
        },
        component: () => import('@/components/companies/EditSuperBonus.vue')
      },
      {
        path: '/companies/edit/superbonus/add/:companyId/:superbonusid',
        name: 'AddSuperBonus',
        meta: {
          title: translations.addSuperBonus,
          parent: 'EditCompany',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati kompanije",
          ],
        },
        component: () => import('@/components/companies/AddSuperBonus.vue')
      },
      {
        path: '/categories/add',
        name: 'AddCategory',
        meta: {
          title: translations.addCategory,
          parent: 'Categories',
          permissions: [
            'Može ažurirati kategorije',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/categories/Add.vue')
      },
      {
        path: '/categories/edit/:id',
        name: 'EditCategory',
        meta: {
          title: translations.editCategory,
          parent: 'Categories',
          permissions: [
            'Može ažurirati kategorije',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/categories/Edit.vue')
      },
      {
        path: '/articles',
        name: 'Articles',
        meta: {
          title: translations.articles,
          permissions: [
            'Vidi artikle',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/articles/List.vue')
      },
      {
        path: '/reviews',
        name: 'Reviews',
        meta: {
          title: 'Recenzije',
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi recenzije",
          ],
        },
        component: () => import('@/components/reviews/List.vue')
      },
      {
        path: '/reviews/edit/:id',
        name: 'EditReview',
        meta: {
          title: 'Ažuriraj recenziju',
          parent: 'Reviews',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati recenzije",
          ],
        },
        component: () => import('@/components/reviews/Edit.vue')
      },
      {
        path: '/articles/add',
        name: 'AddArticle',
        meta: {
          title: translations.addArticle,
          parent: 'Articles',
          permissions: [
            'Može ažurirati artikle',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/articles/Add.vue')
      },
      {
        path: '/articles/copy',
        name: 'CopyArticle',
        meta: {
          title: 'Kopiraj artikal',
          parent: 'Articles',
          permissions: [
            'Može ažurirati artikle',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/articles/Copy.vue')
      },
      {
        path: '/articles/edit/:id',
        name: 'EditArticle',
        meta: {
          title: translations.editArticle,
          parent: 'Articles',
          permissions: [
            'Može ažurirati artikle',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/articles/Edit.vue')
      },
      {
        path: '/articles/import',
        name: 'ImportArticles',
        meta: {
          title: translations.importArticles,
          parent: 'Articles',
          permissions: [
            'Može ažurirati artikle',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/articles/Import.vue')
      },
      {
        path: '/articles/presentation-requests',
        name: 'PresentationRequests',
        meta: {
          title: 'Zahtjevi za prezentaciju',
          parent: 'Articles',
          permissions: [
            'Vidi zahtjeve za prezentacijom proizvoda',
            "Vidi 'Proizvodi'",
          ],
        },
        component: () => import('@/components/articles/PresentationRequests.vue')
      },
      {
        path: '/attributes',
        name: 'Attributes',
        meta: {
          title: translations.attributes,
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi atribute",
          ],
        },
        component: () => import('@/components/attributes/List.vue')
      },
      {
        path: '/attributes/add',
        name: 'AddAttribute',
        meta: {
          title: translations.addAttribute,
          parent: 'Attributes',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati atribute",
          ],
        },
        component: () => import('@/components/attributes/Add.vue')
      },
      {
        path: '/attributes/edit/:id',
        name: 'EditAttribute',
        meta: {
          title: translations.editAttribute,
          parent: 'Attributes',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati atribute",
          ],
        },
        component: () => import('@/components/attributes/Edit.vue')
      },
      {
        path: '/countries',
        name: 'Countries',
        meta: {
          title: translations.countries,
          permissions: [
            "Vidi 'Osnovno'",
            "Vidi države",
          ],
        },
        component: () => import('@/components/countries/List.vue')
      },
      {
        path: '/countries/add',
        name: 'AddCountry',
        meta: {
          title: translations.addCountry,
          parent: 'Countries',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati države",
          ],
        },
        component: () => import('@/components/countries/Add.vue')
      },
      {
        path: '/countries/edit/:id',
        name: 'EditCountry',
        meta: {
          title: translations.editCountry,
          parent: 'Countries',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati države",
          ],
        },
        component: () => import('@/components/countries/Edit.vue')
      },
      {
        path: '/towns',
        name: 'Towns',
        meta: {
          title: translations.towns,
          permissions: [
            "Vidi 'Osnovno'",
            "Vidi gradove",
          ],
        },
        component: () => import('@/components/towns/List.vue')
      },
      {
        path: '/towns/add',
        name: 'AddTown',
        meta: {
          title: translations.addTown,
          parent: 'Towns',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati gradove",
          ],
        },
        component: () => import('@/components/towns/Add.vue')
      },
      {
        path: '/towns/edit/:id',
        name: 'EditTown',
        meta: {
          title: translations.editTown,
          parent: 'Towns',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati gradove",
          ],
        },
        component: () => import('@/components/towns/Edit.vue')
      },
      {
        path: '/banks',
        name: 'Banks',
        meta: {
          title: translations.banks,
          permissions: [
            "Vidi 'Osnovno'",
            "Vidi banke",
          ],
        },
        component: () => import('@/components/banks/List.vue')
      },
      {
        path: '/banks/add',
        name: 'AddBank',
        meta: {
          title: translations.addBank,
          parent: 'Banks',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati banke",
          ],
        },
        component: () => import('@/components/banks/Add.vue')
      },
      {
        path: '/banks/edit/:id',
        name: 'EditBank',
        meta: {
          title: translations.editBank,
          parent: 'Banks',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati banke",
          ],
        },
        component: () => import('@/components/banks/Edit.vue')
      },
      {
        path: '/express-posts',
        name: 'ExpressPosts',
        meta: {
          title: translations.expressPosts,
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi brze pošte",
          ],
        },
        component: () => import('@/components/express-posts/List.vue')
      },
      {
        path: '/express-posts/add',
        name: 'AddExpressPost',
        meta: {
          title: translations.addExpressPost,
          parent: 'ExpressPosts',
          permissions: [
            "Vidi 'Narudžbe'",
            "Može ažurirati brze pošte",
          ],
        },
        component: () => import('@/components/express-posts/Add.vue')
      },
      {
        path: '/express-posts/edit/:id',
        name: 'EditExpressPost',
        meta: {
          title: translations.editExpressPost,
          parent: 'ExpressPosts',
          permissions: [
            "Vidi 'Narudžbe'",
            "Može ažurirati brze pošte",
          ],
        },
        component: () => import('@/components/express-posts/Edit.vue')
      },
      {
        path: '/users',
        name: 'Users',
        meta: {
          title: translations.users,
          permissions: [
            "Vidi 'Klijenti'",
            "Vidi korisnike sistema",
          ],
        },
        component: () => import('@/components/users/List.vue')
      },
      {
        path: '/users/add',
        name: 'AddUser',
        meta: {
          title: translations.addUser,
          parent: 'Users',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati korisnike sistema",
          ],
        },
        component: () => import('@/components/users/Add.vue')
      },
      {
        path: '/users/edit/:id',
        name: 'EditUser',
        meta: {
          title: translations.editUser,
          parent: 'Users',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati korisnike sistema",
          ],
        },
        component: () => import('@/components/users/Edit.vue')
      },
      {
        path: '/users/b2b-customer-requests',
        name: 'CustomerRequests',
        meta: {
          title: 'Korisnički zahtjevi',
          permissions: [
            "Vidi 'Klijenti'",
            "Vidi korisničke zahtjeve",
          ],
        },
        component: () => import('@/components/customer-requests/List.vue')
      },
      {
        path: '/currencies',
        name: 'Currencies',
        meta: {
          title: translations.currencies,
          permissions: [
            "Vidi 'Osnovno'",
            "Vidi valute",
          ],
        },
        component: () => import('@/components/currencies/List.vue')
      },
      {
        path: '/currencies/add',
        name: 'AddCurrency',
        meta: {
          title: translations.addCurrency,
          parent: 'Currencies',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati valute",
          ],
        },
        component: () => import('@/components/currencies/Add.vue')
      },
      {
        path: '/currencies/edit/:id',
        name: 'EditCurrency',
        meta: {
          title: translations.editCurrency,
          parent: 'Currencies',
          permissions: [
            "Vidi 'Osnovno'",
            "Može ažurirati valute",
          ],
        },
        component: () => import('@/components/currencies/Edit.vue')
      },
      {
        path: '/measurement-units',
        name: 'MeasurementUnits',
        meta: {
          title: translations.measurementUnits,
          permissions: [
            "Vidi 'Osnovno'",
            'Vidi jedinice mjere'
          ],
        },
        component: () => import('@/components/measurement-units/List.vue')
      },
      {
        path: '/measurement-units/new',
        name: 'AddMeasurementUnit',
        meta: {
          title: translations.addMeasurementUnit,
          parent: 'MeasurementUnits',
          permissions: [
            "Vidi 'Osnovno'",
            'Može ažurirati jedinice mjere'
          ],
        },
        component: () => import('@/components/measurement-units/Add.vue')
      },
      {
        path: '/measurement-units/edit/:id',
        name: 'EditMeasurementUnit',
        meta: {
          title: translations.editMeasurementUnit,
          parent: 'MeasurementUnits',
          permissions: [
            "Vidi 'Osnovno'",
            'Može ažurirati jedinice mjere'
          ],
        },
        component: () => import('@/components/measurement-units/Edit.vue')
      },
      {
        path: '/user-profile',
        name: 'UserProfile',
        meta: {
          title: translations.userProfile,
        },
        component: () => import('@/components/users/Profile.vue')
      },
      {
        path: '/customer-accounts',
        name: 'CustomerBankAccounts',
        meta: {
          title: translations.customerBankAccounts,
          permissions: [
            "Vidi 'Klijenti'",
            "Vidi bankovne račune",
          ],
        },
        component: () => import('@/components/customer-accounts/List.vue')
      },
      {
        path: '/customer-accounts/add',
        name: 'AddCustomerBankAccount',
        meta: {
          title: translations.addCustomerBankAccount,
          parent: 'CustomerBankAccounts',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati bankovne račune",
          ],
        },
        component: () => import('@/components/customer-accounts/Add.vue')
      },
      {
        path: '/customer-accounts/edit/:id',
        name: 'EditCustomerBankAccount',
        meta: {
          title: translations.editCustomerBankAccount,
          parent: 'CustomerBankAccounts',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati bankovne račune",
          ],
        },
        component: () => import('@/components/customer-accounts/Edit.vue')
      },
      {
        path: '/customer-files',
        name: 'CustomerFiles',
        meta: {
          title: 'Korisničke datoteke',
          permissions: [
            "Vidi 'Klijenti'",
            "Vidi korisničke datoteke",
          ],
        },
        component: () => import('@/components/customer-files/List.vue')
      },
      {
        path: '/customer-files/edit/:id',
        name: 'EditCustomerFile',
        meta: {
          title: translations.editCustomerFile,
          parent: 'CustomerFiles',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati korisničke datoteke",
          ],
        },
        component: () => import('@/components/customer-files/Edit.vue')
      },
      {
        path: '/customer-files/new',
        name: 'NewCustomerFile',
        meta: {
          title: 'Dodaj korisničku datoteku',
          parent: 'CustomerFiles',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati korisničke datoteke",
          ],
        },
        component: () => import('@/components/customer-files/Add.vue')
      },
      {
        path: '/personal-requests',
        name: 'PersonalDataChangeRequests',
        meta: {
          title: 'Zahtjevi - osobni podaci',
          permissions: [
            "Vidi 'Klijenti'",
            "Vidi zahtjeve za promjenom osobnih podataka",
          ],
        },
        component: () => import('@/components/personal-data-change-requests/List.vue')
      },
      {
        path: '/personal-requests/edit/:id',
        name: 'EditPersonalRequestChange',
        meta: {
          title: 'Ažuriraj zahtjev - osobni podaci',
          permissions: [
            "Vidi 'Klijenti'",
            "Može ažurirati zahtjeve za promjenom osobnih podataka",
          ],
        },
        component: () => import('@/components/personal-data-change-requests/Edit.vue')
      },
      {
        path: '/orders',
        name: 'Orders',
        meta: {
          title: translations.orders,
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi narudžbe",
          ],
        },
        component: () => import('@/components/orders/List.vue')
      },
      {
        path: '/out-of-stock-articles',
        name: 'OutOfStockArticles',
        meta: {
          title: 'Artikli na upit',
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi artikle",
          ],
        },
        component: () => import('@/components/out-of-stock-articles/List.vue')
      },
      {
        path: '/out-of-stock-article/:id',
        name: 'EditOutOfStockArticle',
        meta: {
          title: 'Ažuriraj artikal na upit',
          permissions: [
            "Vidi 'Narudžbe'",
            "Može ažurirati artikle",
          ],
        },
        component: () => import('@/components/out-of-stock-articles/Edit.vue')
      },
      {
        path: '/orders/edit/:id',
        name: 'EditOrder',
        meta: {
          title: 'Ažuriraj narudžbu',
          parent: 'Orders',
          permissions: [
            "Vidi 'Narudžbe'",
            "Može ažurirati narudžbe",
          ],
        },
        component: () => import('@/components/orders/Edit.vue'),
      },
      {
        path: '/orders-articles',
        name: 'OrderArticles',
        meta: {
          title: translations.orderArticles,
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi artikle u košarici",
          ],
        },
        component: () => import('@/components/orders-articles/List.vue')
      },
      {
        path: '/wish-lists',
        name: 'WishLists',
        meta: {
          title: translations.wishLists,
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi artikle u košarici",
          ],
        },
        component: () => import('@/components/wish-lists/List.vue')
      },
      {
        path: '/orders-articles/edit/:id',
        name: 'EditOrderArticles',
        meta: {
          title: translations.orderArticles,
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi artikle u košarici",
          ],
        },
        component: () => import('@/components/orders-articles/Edit.vue')
      },
      {
        path: '/wish-list/edit/:id',
        name: 'EditWishList',
        meta: {
          title: translations.wishLists,
          permissions: [
            "Vidi 'Narudžbe'",
            "Vidi artikle u košarici",
          ],
        },
        component: () => import('@/components/wish-lists/Edit.vue')
      },
      {
        path: '/rma',
        name: 'RMA',
        meta: {
          title: translations.rma,
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi reklamacije",
          ],
        },
        component: () => import('@/components/complaints/List.vue')
      },
      {
        path: '/rma/edit/:id',
        name: 'EditRMA',
        meta: {
          title: translations.editRma,
          parent: 'RMA',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati reklamacije",
          ],
        },
        component: () => import('@/components/complaints/Edit.vue')
      },
      {
        path: '/tabs',
        name: 'Tabs',
        meta: {
          title: translations.tabs,
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi tabove",
          ],
        },
        component: () => import('@/components/tabs/List.vue')
      },
      {
        path: '/tabs/add',
        name: 'AddTab',
        meta: {
          title: translations.addTab,
          parent: 'Tabs',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati tabove",
          ],
        },
        component: () => import('@/components/tabs/Add.vue')
      },
      {
        path: '/tabs/edit/:id',
        name: 'EditTab',
        meta: {
          title: translations.editTab,
          parent: 'Tabs',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati tabove",
          ],
        },
        component: () => import('@/components/tabs/Edit.vue')
      },
      {
        path: '/tags',
        name: 'Tags',
        meta: {
          title: translations.tags,
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati tabove",
          ],
        },
        component: () => import('@/components/tags/List.vue')
      },
      {
        path: '/tags/add',
        name: 'AddTag',
        meta: {
          title: translations.addTag,
          parent: 'Tags',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati tagove",
          ],
        },
        component: () => import('@/components/tags/Add.vue')
      },
      {
        path: '/tags/edit/:id',
        name: 'EditTag',
        meta: {
          title: translations.editTag,
          parent: 'Tags',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati tagove",
          ],
        },
        component: () => import('@/components/tags/Edit.vue')
      },
      {
        path: '/brands',
        name: 'Brands',
        meta: {
          title: translations.brands,
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi brendove",
          ],
        },
        component: () => import('@/components/brands/List.vue')
      },
      {
        path: '/brands/add',
        name: 'AddBrand',
        meta: {
          title: translations.addBrand,
          parent: 'Brands',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati brendove",
          ],
        },
        component: () => import('@/components/brands/Add.vue')
      },
      {
        path: '/brands/edit/:id',
        name: 'EditBrand',
        meta: {
          title: translations.editBrand,
          parent: 'Brands',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati brendove",
          ],
        },
        component: () => import('@/components/brands/Edit.vue')
      },
      {
        path: '/product-sales',
        name: 'ProductSales',
        meta: {
          title: translations.productSales,
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi akcije",
          ],
        },
        component: () => import('@/components/product-sales/List.vue')
      },
      {
        path: '/product-sales/add',
        name: 'AddProductSale',
        meta: {
          title: translations.addProductSale,
          parent: 'ProductSales',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati akcije",
          ],
        },
        component: () => import('@/components/product-sales/Add.vue')
      },
      {
        path: '/product-sales/edit/:id',
        name: 'EditProductSale',
        meta: {
          title: translations.editProductSale,
          parent: 'ProductSales',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati akcije",
          ],
        },
        component: () => import('@/components/product-sales/Edit.vue')
      },
      {
        path: '/interests-areas',
        name: 'InterestsAreas',
        meta: {
          title: translations.interestsAreas,
          permissions: [
            "Vidi 'Proizvodi'",
            "Vidi područja interesovanja",
          ],
        },
        component: () => import('@/components/interests-areas/List.vue')
      },
      {
        path: '/interests-areas/add',
        name: 'AddInterestsArea',
        meta: {
          title: translations.addInterestsArea,
          parent: 'InterestsAreas',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati područja interesovanja",
          ],
        },
        component: () => import('@/components/interests-areas/Add.vue')
      },
      {
        path: '/interests-areas/edit/:id',
        name: 'EditInterestsArea',
        meta: {
          title: translations.editInterestsArea,
          parent: 'InterestsAreas',
          permissions: [
            "Vidi 'Proizvodi'",
            "Može ažurirati područja interesovanja",
          ],
        },
        component: () => import('@/components/interests-areas/Edit.vue')
      },
      {
        path: '/blogs',
        name: 'Blogs',
        meta: {
          title: translations.blogs,
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi novosti",
          ],
        },
        component: () => import('@/components/blogs/List.vue')
      },
      {
        path: '/blogs/add',
        name: 'AddBlog',
        meta: {
          title: translations.addBlog,
          parent: 'Blogs',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati novosti",
          ],
        },
        component: () => import('@/components/blogs/Add.vue')
      },
      {
        path: '/blogs/copy',
        name: 'CopyBlog',
        meta: {
          title: 'Kopiraj novost',
          parent: 'Blogs',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati novosti",
          ],
        },
        component: () => import('@/components/blogs/Copy.vue')
      },
      {
        path: '/blogs/edit/:id',
        name: 'EditBlog',
        meta: {
          title: translations.editBlog,
          parent: 'Blogs',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati novosti",
          ],
        },
        component: () => import('@/components/blogs/Edit.vue')
      },
      {
        path: '/polls',
        name: 'Polls',
        meta: {
          title: translations.polls,
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi ankete",
          ],
        },
        component: () => import('@/components/ComingSoon.vue')
      },
      {
        path: '/service-managers',
        name: 'ServiceManagers',
        meta: {
          title: 'Voditelji servisa',
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi voditelje servisa",
          ],
        },
        component: () => import('@/components/service-managers/List.vue')
      },
      {
        path: '/service-managers/new',
        name: 'AddServiceManager',
        meta: {
          title: 'Dodaj voditelja servisa',
          parent: 'ServiceManagers',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati voditelje servisa",
          ],
        },
        component: () => import('@/components/service-managers/Add.vue')
      },
      {
        path: '/service-managers/edit/:id',
        name: 'EditServiceManager',
        meta: {
          title: 'Ažuriraj voditelja servisa',
          parent: 'ServiceManagers',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati voditelje servisa",
          ],
        },
        component: () => import('@/components/service-managers/Edit.vue')
      },
      {
        path: '/terms',
        name: 'Terms',
        meta: {
          title: translations.terms,
          permissions: [
            "Vidi 'Ostalo'",
          ],
        },
        component: () => import('@/components/terms-of-services/TermsOfServices.vue')
      },
      {
        path: '/coupons',
        name: 'Coupons',
        meta: {
          title: translations.coupons,
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi kodove za popust pri kupovini",
          ],
        },
        component: () => import('@/components/coupons/List.vue')
      },
      {
        path: '/coupons/new',
        name: 'AddCoupon',
        meta: {
          title: 'Dodaj promo kôd',
          parent: 'Coupons',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati kodove za popust pri kupovini",
          ],
        },
        component: () => import('@/components/coupons/Add.vue')
      },
      {
        path: '/coupons/edit/:id/:type',
        name: 'EditPromoCode',
        meta: {
          title: 'Ažuriraj promo kôd',
          parent: 'Coupons',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati kodove za popust pri kupovini",
          ],
        },
        component: () => import('@/components/coupons/Edit.vue')
      },
      {
        path: '/gift-cards',
        name: 'GiftCards',
        meta: {
          title: 'Poklon kartice',
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi kodove za popust pri kupovini",
          ],
        },
        component: () => import('@/components/gift-cards/List.vue')
      },
      {
        path: '/gift-cards/new',
        name: 'AddGiftCard',
        meta: {
          title: 'Dodaj poklon kôd',
          parent: 'GiftCards',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati kodove za popust pri kupovini",
          ],
        },
        component: () => import('@/components/gift-cards/Add.vue')
      },
      {
        path: '/gift-cards/edit/:id',
        name: 'EditGiftCard',
        meta: {
          title: 'Ažuriraj poklon kôd',
          parent: 'GiftCards',
          permissions: [
            "Vidi 'Ostalo'",
            "Može ažurirati kodove za popust pri kupovini",
          ],
        },
        component: () => import('@/components/gift-cards/Edit.vue')
      },
      {
        path: '/newsletters',
        name: 'Newsletters',
        meta: {
          title: 'Newsletter korisnici',
          permissions: [
            "Vidi 'Ostalo'",
            "Vidi newsletter korisnike",
          ],
        },
        component: () => import('@/components/newsletters/List.vue')
      },
      {
        path: '/sliders',
        name: 'Sliders',
        meta: {
          title: 'Postavke glavnih slidera',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/Sliders/List.vue')
      },
      {
        path: '/sliders/new',
        name: 'AddSlider',
        meta: {
          title: 'Dodaj novi slider',
          parent: 'Sliders',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/Sliders/Add.vue')
      },
      {
        path: '/sliders/edit/:id',
        name: 'EditSlider',
        meta: {
          title: 'Ažuriraj slider',
          parent: 'Sliders',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/Sliders/Edit.vue')
      },
      {
        path: '/featured-categories',
        name: 'FeaturedCategories',
        meta: {
          title: 'Izdvojeno',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/highlighted-categories/List.vue')
      },
      {
        path: '/featured-categories/new',
        name: 'AddFeaturedCategory',
        meta: {
          title: 'Dodaj izdvojenu kategoriju',
          parent: 'FeaturedCategories',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/highlighted-categories/Add.vue')
      },
      {
        path: '/featured-categories/edit/:id',
        name: 'EditFeaturedCategory',
        meta: {
          title: 'Ažuriraj izdvojenu kategoriju',
          parent: 'FeaturedCategories',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/highlighted-categories/Edit.vue')
      },
      {
        path: '/banners',
        name: 'Banners',
        meta: {
          title: 'Banneri',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/banners/List.vue')
      },
      {
        path: '/banners/new',
        name: 'AddBanner',
        meta: {
          title: 'Dodaj banner',
          parent: 'Banners',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/banners/Add.vue')
      },
      {
        path: '/banners/edit/:id',
        name: 'EditBanner',
        meta: {
          title: 'Ažuriraj banner',
          parent: 'Banners',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/banners/Edit.vue')
      },
      {
        path: '/featured-brands',
        name: 'HighlightedBrands',
        meta: {
          title: 'Istaknuti brandovi',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/highlighted-brands/List.vue')
      },
      {
        path: '/featured-brands/new',
        name: 'AddHighlightedBrand',
        meta: {
          title: 'Dodaj istaknuti brand',
          parent: 'HighlightedBrands',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/highlighted-brands/Add.vue')
      },
      {
        path: '/featured-brands/edit/:id',
        name: 'EditHighlightedBrand',
        meta: {
          title: 'Ažuriraj istaknuti brand',
          parent: 'HighlightedBrands',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/highlighted-brands/Edit.vue')
      },
      {
        path: '/top-brands',
        name: 'TopBrands',
        meta: {
          title: 'Top brendovi',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/top-brands/List.vue')
      },
      {
        path: '/top-brands/new',
        name: 'AddTopBrand',
        meta: {
          title: 'Dodaj top brendove',
          parent: 'TopBrands',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/top-brands/Add.vue')
      },
      {
        path: '/top-brands/edit/:id',
        name: 'EditTopBrand',
        meta: {
          title: 'Ažuriraj top brendove',
          parent: 'TopBrands',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        beforeEnter: async (to, from, next) => {
          await store.dispatch('getTopBrandListById', parseInt(to.params.id, 10));

          setTimeout(() => {
            next();
          }, 200);
        },
        component: () => import('@/components/dashboard-settings/top-brands/Edit.vue')
      },
      {
        path: '/footer-settings',
        name: 'FooterSettings',
        meta: {
          title: 'Footer',
          permissions: [
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/ComingSoon.vue')
      },
      {
        path: '/new-articles',
        name: 'NewArticles',
        meta: {
          title: 'Novi artikli',
          permissions: [
            'Vidi artikle',
            "Vidi 'Postavke početne stranice'",
          ],
        },
        component: () => import('@/components/dashboard-settings/Articles.vue')
      },
      {
        path: '/system-messages',
        name: 'SystemMessages',
        meta: {
          title: 'Sistemske poruke',
          permissions: [
            "Vidi 'Sistemske poruke'",
            'Vidi sistemske poruke'
          ],
        },
        component: () => import('@/components/system-messages/List.vue')
      },
      {
        path: '/system-messages/new',
        name: 'AddSystemMessage',
        meta: {
          title: 'Kreiraj sistemsku poruku',
          parent: 'SystemMessages',
          permissions: [
            "Vidi 'Sistemske poruke'",
            'Može ažurirati sistemske poruke'
          ],
        },
        component: () => import('@/components/system-messages/Add.vue')
      },
      {
        path: '/user-roles',
        name: 'UserRoles',
        meta: {
          title: 'Korisničke uloge',
          permissions: [
            "Vidi 'Korisničke uloge'",
          ],
        },
        component: () => import('@/components/roles/List.vue')
      },
      {
        path: '/user-roles/add',
        name: 'AddUserRole',
        meta: {
          title: 'Dodaj korisničku ulogu',
          parent: 'UserRoles',
          permissions: [
            "Vidi 'Korisničke uloge'",
          ],
        },
        component: () => import('@/components/roles/Add.vue')
      },
      {
        path: '/user-roles/edit/:id',
        name: 'EditUserRole',
        meta: {
          title: 'Ažuriraj korisničku ulogu',
          parent: 'UserRoles',
          permissions: [
            "Vidi 'Korisničke uloge'",
          ],
        },
        component: () => import('@/components/roles/Edit.vue')
      },
      {
        path: '/cleaning-plans',
        name: 'CleaningPlans',
        meta: {
          title: 'Planovi čišćenja',
          permissions: [
            'Vidi planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plans/List.vue')
      },
      {
        path: '/cleaning-plans/add',
        name: 'AddCleaningPlan',
        meta: {
          title: 'Dodaj plan čišćenja',
          parent: 'CleaningPlans',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plans/Add.vue')
      },
      {
        path: '/cleaning-plans/edit/:id',
        name: 'EditAddCleaningPlan',
        meta: {
          title: 'Ažuriraj plan čišćenja',
          parent: 'CleaningPlans',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plans/Edit.vue')
      },
      {
        path: '/cleaning-plans/print/:id',
        name: 'PrintCleaningPlan',
        meta: {
          title: 'Print plana čišćenja',
          parent: 'CleaningPlans',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plans/Print.vue'),
      },
      {
        path: '/cleaning-areas',
        name: 'CleaningAreas',
        meta: {
          title: 'Područja primjene',
          permissions: [
            'Vidi planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/components/cleaning-areas/List.vue')
      },
      {
        path: '/cleaning-areas/add',
        name: 'AddCleaningArea',
        meta: {
          title: 'Dodaj novo područje primjene',
          parent: 'CleaningAreas',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/components/cleaning-areas/Add.vue')
      },
      {
        path: '/cleaning-areas/edit/:id',
        name: 'EditCleaningArea',
        meta: {
          title: 'Ažuriraj područje primjene',
          parent: 'CleaningAreas',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/components/cleaning-areas/Edit.vue')
      },
      {
        path: '/cleaning-note-icons',
        name: 'CleaningNoteIcons',
        meta: {
          title: 'Ikone napomene čišćenja',
          permissions: [
            'Vidi planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plan-note-icons/List.vue')
      },
      {
        path: '/cleaning-note-icons/add',
        name: 'AddCleaningPlanNoteIcon',
        meta: {
          title: 'Dodaj ikonu plana čišćenja',
          parent: 'CleaningNoteIcons',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plan-note-icons/Add.vue')
      },
      {
        path: '/cleaning-note-icons/edit/:id',
        name: 'EditCleaningPlaningNoteIcon',
        meta: {
          title: 'Ažuriraj ikonu plana čišćenja',
          parent: 'CleaningNoteIcons',
          permissions: [
            'Može ažurirati planove čišćenja',
            "Vidi 'Planovi čišćenja'",
          ],
        },
        component: () => import('@/views/cleaning-plan-note-icons/Edit.vue')
      },
      {
        path: '/advanced-offers',
        name: 'AdvancedOffers',
        meta: {
          // title: 'Napredne ponude',
          title: 'Ponude',
          permissions: [
            'Vidi ponude',
            "Vidi 'Dokumenti'"
          ],
        },
        component: () => import('@/components/offers-advanced/List.vue')
      },
      {
        path: '/advanced-offers/add',
        name: 'AddAdvancedOffer',
        meta: {
          title: 'Dodaj ponudu',
          // title: 'Dodaj naprednu ponudu',
          parent: 'AdvancedOffers',
          permissions: [
            'Može ažurirati ponude',
            "Vidi 'Dokumenti'"
          ],
        },
        component: () => import('@/components/offers-advanced/Add.vue')
      },
      {
        path: '/offers',
        name: 'Offers',
        meta: {
          title: 'Ponude',
          permissions: [
            'Vidi ponude',
            "Vidi 'Dokumenti'"
          ],
        },
        component: () => import('@/components/offers/List.vue')
      },
      {
        path: '/offers/add',
        name: 'AddOffer',
        meta: {
          title: 'Dodaj ponudu',
          parent: 'Offers',
          permissions: [
            'Može ažurirati ponude',
            "Vidi 'Dokumenti'"
          ],
        },
        component: () => import('@/components/offers/Add.vue')
      },
      {
        path: '/offers/edit/:id',
        name: 'EditOffer',
        meta: {
          title: 'Ažuriraj ponudu',
          parent: 'Offers',
          permissions: [
            'Može ažurirati ponude',
            "Vidi 'Dokumenti'"
          ],
        },
        component: () => import('@/components/offers/Edit.vue')
      },
      {
        path: '/advanced-offers/edit/:id',
        name: 'EditAdvancedOffer',
        meta: {
          title: 'Ažuriraj ponudu',
          // title: 'Ažuriraj naprednu ponudu',
          parent: 'AdvancedOffers',
          permissions: [
            'Može ažurirati ponude',
            "Vidi 'Dokumenti'"
          ],
        },
        component: () => import('@/components/offers-advanced/Edit.vue')
      },
      {
        path: '/settings',
        name: 'Settings',
        meta: {
          title: 'B2B Postavke',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/components/settings/List.vue'),
      },
      {
        path: '/article-settings',
        name: 'ArticleSettings',
        meta: {
          title: 'B2B Postavke artikala',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/ArticleSettings.vue'),
      },
      {
        path: '/blog-settings',
        name: 'BlogSettings',
        meta: {
          title: 'B2B Postavke novosti',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/BlogSettings.vue'),
      },
      {
        path: '/customer-settings',
        name: 'CustomerSettings',
        meta: {
          title: 'B2B Korisničke postavke',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/CustomerSettings.vue'),
      },
      {
        path: '/general-settings',
        name: 'GeneralSettings',
        meta: {
          title: 'B2B Opće postavke',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/GeneralSettings.vue'),
      },
      {
        path: '/media-library-settings',
        name: 'MediaLibrarySettings',
        meta: {
          title: 'B2B Postavke biblioteke',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/MediaLibrarySettings.vue'),
      },
      {
        path: '/order-settings',
        name: 'OrderSettings',
        meta: {
          title: 'B2B Postavke narudžbi',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/OrderSettings.vue'),
      },
      {
        path: '/shipping-settings',
        name: 'ShippingSettings',
        meta: {
          title: 'B2B Postavke dostave',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/ShippingSettings.vue'),
      },
      {
        path: '/language-settings',
        name: 'LanguageSettings',
        meta: {
          title: 'B2B Postavke jezika',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/LanguageSettings.vue'),
      },
      {
        path: '/shopping-cart-settings',
        name: 'ShoppingCartSettings',
        meta: {
          title: 'B2B Postavke košarice',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/ShoppingCartSettings.vue'),
      },
      {
        path: '/offer-settings',
        name: 'OfferSettings',
        meta: {
          title: 'B2B Postavke ponuda',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/OfferSettings.vue'),
      },
      {
        path: '/tax-settings',
        name: 'TaxSettings',
        meta: {
          title: 'B2B Postavke poreza',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/TaxSettings.vue'),
      },
      {
        path: '/user-articles-settings',
        name: 'UserArticlesSettings',
        meta: {
          title: 'B2B Postavke proizvoda za vas',
          permissions: [
            'Vidi \'B2B Postavke\''
          ],
        },
        component: () => import('@/views/settings/UserArticlesSettings.vue'),
      },
      {
        path: '/b2c-article-settings',
        name: 'B2CArticleSettings',
        meta: {
          title: 'B2C Postavke artikala',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/ArticleSettings.vue'),
      },
      {
        path: '/b2c-user-articles-settings',
        name: 'B2CUserArticlesSettings',
        meta: {
          title: 'B2C Postavke proizvoda za vas',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/UserArticlesSettings.vue'),
      },
      {
        path: '/b2c-bestsellers-settings',
        name: 'B2CBestsellersSettings',
        meta: {
          title: 'B2C Postavke bestsellera',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/BestsellersSettings.vue'),
      },
      {
        path: '/b2c-blog-settings',
        name: 'B2CBlogSettings',
        meta: {
          title: 'B2C Postavke novosti',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/BlogSettings.vue'),
      },
      {
        path: '/b2c-customer-settings',
        name: 'B2CCustomerSettings',
        meta: {
          title: 'B2C Korisničke postavke',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/CustomerSettings.vue'),
      },
      {
        path: '/b2c-general-settings',
        name: 'B2CGeneralSettings',
        meta: {
          title: 'B2C Opće postavke',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/GeneralSettings.vue'),
      },
      {
        path: '/b2c-media-library-settings',
        name: 'B2CMediaLibrarySettings',
        meta: {
          title: 'B2C Postavke biblioteke',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/MediaLibrarySettings.vue'),
      },
      {
        path: '/b2c-order-settings',
        name: 'B2COrderSettings',
        meta: {
          title: 'B2C Postavke narudžbi',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/OrderSettings.vue'),
      },
      {
        path: '/b2c-shipping-settings',
        name: 'B2CShippingSettings',
        meta: {
          title: 'B2C Postavke dostave',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/ShippingSettings.vue'),
      },
      {
        path: '/b2c-shopping-cart-settings',
        name: 'B2CShoppingCartSettings',
        meta: {
          title: 'B2C Postavke košarice',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/ShoppingCartSettings.vue'),
      },
      {
        path: '/b2c-tax-settings',
        name: 'B2CTaxSettings',
        meta: {
          title: 'B2C Postavke poreza',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/views/b2c-settings/TaxSettings.vue'),
      },
      {
        path: '/meta-seo-settings/homepage',
        name: 'MetaSeoHomepage',
        meta: {
          title: 'Postavke - Početna',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/components/meta-seo/Homepage.vue'),
      },
      {
        path: '/meta-seo-settings/brands',
        name: 'MetaSeoBrands',
        meta: {
          title: 'Postavke - Brendovi',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/components/meta-seo/Brands.vue'),
      },
      {
        path: '/meta-seo-settings/actions',
        name: 'MetaSeoActions',
        meta: {
          title: 'Postavke - Akcije',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/components/meta-seo/Actions.vue'),
      },
      {
        path: '/meta-seo-settings/blogs',
        name: 'MetaSeoBlogs',
        meta: {
          title: 'Postavke - Vijesti',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/components/meta-seo/Blogs.vue'),
      },
      {
        path: '/meta-seo-settings/about',
        name: 'MetaSeoAbout',
        meta: {
          title: 'Postavke - O nama',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/components/meta-seo/About.vue'),
      },
      {
        path: '/meta-seo-settings/contact',
        name: 'MetaSeoContact',
        meta: {
          title: 'Postavke - Kontakt',
          permissions: [
            'Vidi \'B2C Postavke\''
          ],
        },
        component: () => import('@/components/meta-seo/Contact.vue'),
      },
      {
        path: '/403',
        name: 'Forbidden',
        meta: {
          title: 'Zabranjen pristup',
        },
        component: () => import('@/components/Forbidden.vue'),
      },
      {
        path: '*',
        meta: {
          title: translations.notFound
        },
        component: () => import('@/components/NotFound.vue')
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  // scrollBehavior() {
  //   return {
  //     x: 0,
  //     y: 0,
  //     behavior: 'smooth',
  //   };
  // },
});


router.beforeEach((to, from, next) => {
  const loggedUserPermissions = store.getters.getLoggedUserPermissions;
  
  const { permissions } = to.meta;
  if (permissions?.length) {
    const hasValidPermission = permissions.every(
      (permission) => helpers.hasPermission(permission, loggedUserPermissions)
    );
    if (hasValidPermission) {
      next();
      return;
    }
    next({ name: 'Forbidden' });
  } else {
    next();
  }
});

router.afterEach((to) => {
  document.title = `${to.meta.title} - ${config.appTitle}`;
});

export default router;
export {
  routes,
};
